import React from 'react'
import PropTypes from 'prop-types'
import Carousel from 'nuka-carousel'
import { Element } from 'react-scroll'

import Icon from 'Pods/Shared/Icon/Icon'

import IntelLogo from 'images/investors/intel.png'
import PracticaLogo from 'images/investors/practica_capital.png'
import KarmaLogo from 'images/investors/karma.png'

import Section from './Section'

function Investors({ isMobile, id }) {
  const InvestorsList = ([
    <div className="investor-wrapper" key="intel">
      <a href="http://www.intelcapital.com" target="_blank" rel="noopener noreferrer">
        <img src={IntelLogo} alt="Intel Capital" />
      </a>
    </div>,
    <div className="investor-wrapper" key="practica">
      <a href="http://practica.vc" target="_blank" rel="noopener noreferrer">
        <img src={PracticaLogo} alt="Practica Capital" />
      </a>
    </div>,
    <div className="investor-wrapper" key="karma">
      <a href="http://www.karma.vc" target="_blank" rel="noopener noreferrer">
        <img src={KarmaLogo} alt="karma.vc" />
      </a>
    </div>,
  ])

  return (
    <Element id={id} className="element">
      <Section sectionClassName="info-section investors-section">
        <div className="col-12">
          <h2 className="heading-24 info-section__heading">Investors</h2>
          <p className="info-section__description">
            CGTrader works with some of the world’s leading investment firms to help us invest in marketplace growth
            and continue to develop new innovative enterprise solutions.
          </p>
          {isMobile ? (
            <div className="investors-container">
              <Carousel
                slidesToShow={1}
                cellSpacing={0}
                wrapAround
                speed={1000}
                cellAlign="center"
                transitionMode="scroll"
                heightMode="max"
                slideIndex={0}
                autoplay
                autoplayInterval={6000}
                renderCenterLeftControls={({ previousSlide }) => (
                  <button className="btn btn-transparent is-with-opacity" onClick={previousSlide}>
                    <Icon type={['far', 'chevron-left']} className="height-36" notSpaced />
                  </button>
                )}
                renderCenterRightControls={({ nextSlide }) => (
                  <button className="btn btn-transparent is-with-opacity" onClick={nextSlide}>
                    <Icon type={['far', 'chevron-right']} className="height-36" notSpaced />
                  </button>
                )}
              >
                {InvestorsList}
              </Carousel>
            </div>
          ) : (
            <div className="container-fixed">
              <div className="investors-container">
                {InvestorsList}
              </div>
            </div>
          )}
        </div>
      </Section>
    </Element>
  )
}

Investors.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
}

export default Investors
